/* Search suggestions while typing (sections/predictive-search.liquid). Added 2026-10-22.
   The header search icon opens a search bar; two or more letters fetch up to six products
   from the store search (prefix matching), rendered by Liquid in the page's language. Enter goes
   to the full results page. On the search page itself the icon keeps its normal link. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var box = document.getElementById('abSearch');
  var input = document.getElementById('abSearchInput');
  var results = document.getElementById('abSearchResults');
  if (!box || !input || !results || !window.fetch) return;
  var onSearchPage = /\/search\/?$/.test(location.pathname);
  var timer = null, ctrl = null, lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('open'); });
    document.documentElement.classList.add('ab-drawer-lock');
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    box.classList.remove('open');
    document.documentElement.classList.remove('ab-drawer-lock');
    setTimeout(function () { box.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function suggest(q) {
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    // the normal search, not /search/suggest: suggest refuses the Arabic locale
    var url = root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=predictive-search';
    fetch(url, ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('suggest'); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        results.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var icon = e.target.closest && e.target.closest('[data-search-open]');
    if (icon && !onSearchPage && !e.metaKey && !e.ctrlKey) { e.preventDefault(); open(); return; }
    if (e.target === box || (e.target.closest && e.target.closest('[data-search-close]'))) { e.preventDefault(); close(); }
  });
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(function () { suggest(q); }, 220);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box.classList.contains('open')) close();
  });
})();
